module.exports = __webpack_public_path__ + "static/img/ewm.b21aec6.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewm.jpeg
// module id = uSjb
// module chunks = 6